import { ChangeDetectorRef, Component, EventEmitter, inject, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

/** How long the zoom level stays up after a change (ms) */
const PILL_MS = 1000;

/**
 * W66: the sheet viewers' zoom and full-screen controls, the map's stack (map-wrapper): white 44px circles with the
 * map's shadow and icons, bottom-right, +, −, then Full screen. The host places it over its frame (not inside the
 * scrolling area). A zoom change shows the level ("1.5×") beside the stack for a moment. Standalone (W75): the record
 * Location dialog's Drawing tab uses it too.
 */
@Component({
  selector: 'app-sheet-zoom-controls',
  templateUrl: './sheet-zoom-controls.component.html',
  styleUrls: ['./sheet-zoom-controls.component.scss'],
  imports: [DecimalPipe, MatIconModule],
})
export class SheetZoomControlsComponent implements OnChanges, OnDestroy {
  @Input() zoom = 1;
  @Input() canZoomIn = true;
  @Input() canZoomOut = true;
  /** null: no full-screen button (the set review's page viewer) */
  @Input() fullScreen: boolean | null = null;
  /** A Fit button under − (back to the whole page), for hosts whose zoom has no other way home (the markup editor) */
  @Input() showFit = false;
  @Input() canFit = true;
  /** data-testid prefix: `<prefix>-zoom-in`, `-zoom-out`, `-fit`, `-fullscreen`, `-zoom` */
  @Input() testIdPrefix = 'sheet';
  @Output() zoomIn = new EventEmitter<void>();
  @Output() zoomOut = new EventEmitter<void>();
  @Output() fit = new EventEmitter<void>();
  @Output() fullScreenChange = new EventEmitter<boolean>();
  pillVisible = false;
  private pillTimer: ReturnType<typeof setTimeout> | null = null;
  private readonly cdr = inject(ChangeDetectorRef);

  ngOnChanges(changes: SimpleChanges): void {
    const z = changes.zoom;
    if (z && !z.firstChange && z.previousValue !== z.currentValue) {
      this.pillVisible = true;
      if (this.pillTimer) {
        clearTimeout(this.pillTimer);
      }
      this.pillTimer = setTimeout(() => {
        this.pillVisible = false;
        this.pillTimer = null;
        this.cdr.markForCheck();
      }, PILL_MS);
    }
  }

  ngOnDestroy(): void {
    if (this.pillTimer) {
      clearTimeout(this.pillTimer);
    }
  }
}
